import AsoHeader from '../../../components/Aso/Header';
import AsoAceite from '../../../components/Aso/Register/AsoAceite';

export function AsoRegistro() {

  return (
    <div>
      <AsoHeader />
      <AsoAceite />
    </div>
  );
}
